/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import NotesIcon from '@mui/icons-material/Notes'

import { viewFeedbackAndVerdictForItemJSX } from '../../../analysisJSX/viewFeedbackAndVerdictForItemJSX'

import { positionChangeWidthSm, navbarHeight, footerHeight, hingeProfileBackgroundColor, hingeProfileImageDimension, hingeProfileItemBorderColor, hingeProfileItemDividerOpacity, hingeProfileItemBoxShadow, hingeProfileItemBorderWidth, hingeProfileItemBorderRadius, swipelyticsTurquoise, profPicDefaultURL } from '../../../../../helpers/variableDefaults'

export const viewHingeImageItem = (viewFeedbackTrue, giveFeedbackTrue, imageIndex, datingProfile, showSubcaption, setShowSubcaption, mediaIsLoading, setMediaIsLoading, width) => {
  // console.log('imageIndex ->', imageIndex)
  // console.log('datingProfile.media ->', datingProfile.media[imageIndex])
  // console.log('datingProfile.mediaFeedback ->', datingProfile.mediaFeedback[imageIndex])

  const handleShowSubcaption = () => {
    // console.log('handleShowSubcaption runs index ->', imageIndex)
    setShowSubcaption({ ...showSubcaption, [`mediaItem${imageIndex + 1}`]: !showSubcaption[`mediaItem${imageIndex + 1}`] })
  }

  return (
    <Box
      sx={{
        mt: 3,
        boxShadow: hingeProfileItemBoxShadow, 
        border: hingeProfileItemBorderWidth,
        borderColor: hingeProfileItemBorderColor,
        borderRadius: hingeProfileItemBorderRadius,
      }}
    >
      {/* Caption */}
      {(datingProfile.media[imageIndex].caption.length > 0 && datingProfile.media[imageIndex].caption !== 'No Caption') &&
        <Box
          sx={{
            py: 2, px: 2,
            width: hingeProfileImageDimension(width),
            backgroundColor: 'white',
            fontWeight: 'bold',
            borderRadius: `${hingeProfileItemBorderRadius} ${hingeProfileItemBorderRadius} 0px 0px`, 
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >
          {datingProfile.media[imageIndex].caption}
        </Box>
      }
      
      {/* Divider */}
      {datingProfile.media[imageIndex].caption.length > 0 && datingProfile.media[imageIndex].caption !== 'No Caption' &&
        <Divider sx={{ width: '100%', my: 0, opacity: hingeProfileItemDividerOpacity }} orientation="horizontal" />
      }

      {/* Image/Video */}
      <Box 
        component={datingProfile.media[imageIndex].mediaType === 'video' ? 'video' : ''}
        onLoadStart={() => setMediaIsLoading({ ...mediaIsLoading, [`mediaItem${imageIndex + 1}`]: true })}
        onLoadedData={() => setMediaIsLoading({ ...mediaIsLoading, [`mediaItem${imageIndex + 1}`]: false })}
        src={datingProfile.media[imageIndex].mediaType === 'video' ? datingProfile.media[imageIndex].mediaItemURL : null} 
        onClick={handleShowSubcaption}
        disabled={!('subcaption' in datingProfile.media[imageIndex]) || datingProfile.media[imageIndex].subcaption.length > 0 }
        autoPlay={datingProfile.media[imageIndex].mediaType === 'video' ? true : false}
        playsInline={datingProfile.media[imageIndex].mediaType === 'video' ? true : false}
        loop={datingProfile.media[imageIndex].mediaType === 'video' ? true : false}
        muted={datingProfile.media[imageIndex].mediaType === 'video' ? true : true}
        sx={{ 
          // mt: 1,
          width: hingeProfileImageDimension(width),
          height: hingeProfileImageDimension(width),
          backgroundImage: `url(${datingProfile.media[imageIndex].mediaItemURL})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          // boxShadow: 3, 
          borderRadius: 
            (datingProfile.media[imageIndex].caption.length === 0 || datingProfile.media[imageIndex].caption === 'No Caption') && !viewFeedbackTrue && !giveFeedbackTrue
              ? 
              `${hingeProfileItemBorderRadius}` 
              : 
              (datingProfile.media[imageIndex].caption.length === 0 || datingProfile.media[imageIndex].caption === 'No Caption') 
                ? 
                `${hingeProfileItemBorderRadius} ${hingeProfileItemBorderRadius} 0px 0px` 
                : 
                (!viewFeedbackTrue && !giveFeedbackTrue)
                  ? 
                  `0px 0px ${hingeProfileItemBorderRadius} ${hingeProfileItemBorderRadius}`
                  : 
                  '0px'
          , 
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-end', 
        }}
      >
        {/* {console.log(`imageIndex + 1 is ${imageIndex + 1} ->`, showSubcaption[`mediaItem${imageIndex + 1}`])}
        {console.log('subcaption ->', datingProfile.media[imageIndex].subcaption.length > 0)} */}
        {mediaIsLoading[`mediaItem${imageIndex + 1}`]
          &&
          <Box
            sx={{
              // position: 'relative',
              color: 'blue',
              width: hingeProfileImageDimension(width),
              height: hingeProfileImageDimension(width),
              display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', 
            }}
          >
            Media is Loading...
          </Box>
        }
        {!showSubcaption[`mediaItem${imageIndex + 1}`] 
        && !mediaIsLoading[`mediaItem${imageIndex + 1}`]
        && datingProfile.media[imageIndex].subcaption.length > 0
        &&
          <Box
            sx={{
              width: '100%',
              display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            <Box
              sx={{
                m: 1,
                backgroundColor: 'dimgray',
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
              }}
            >
              <NotesIcon 
                sx={{
                  color: 'white',
                  width: '15px',
                  height: '15px',
                }}
              />
            </Box>
          </Box>
        }
        
        {showSubcaption[`mediaItem${imageIndex + 1}`] 
        && !mediaIsLoading[`mediaItem${imageIndex + 1}`]
        && datingProfile.media[imageIndex].subcaption.length > 0
        &&
          <Box
            textAlign={'center'}
            sx={{
              px: 2,
              width: hingeProfileImageDimension(width),
              height: hingeProfileImageDimension(width),
              backgroundColor: 'dimgray',
              color: 'white',
              opacity: '90%',
              borderRadius: 
                datingProfile.media[imageIndex].caption === 'No Caption' && !viewFeedbackTrue && !giveFeedbackTrue
                  ? 
                  `${hingeProfileItemBorderRadius}` 
                  : 
                  datingProfile.media[imageIndex].caption === 'No Caption' 
                    ? 
                    `${hingeProfileItemBorderRadius} ${hingeProfileItemBorderRadius} 0px 0px` 
                    : 
                    (!viewFeedbackTrue && !giveFeedbackTrue)
                      ? 
                      `0px 0px ${hingeProfileItemBorderRadius} ${hingeProfileItemBorderRadius}` 
                      : 
                      '0px'
              ,
              display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
            }}
          >
            {datingProfile.media[imageIndex].subcaption}
          </Box>
        }
      </Box>

      {viewFeedbackTrue && datingProfile.mediaFeedback[imageIndex].feedback.length > 0 && datingProfile.mediaFeedback[imageIndex].verdict.length > 0 && 
        <Box
          sx={{
            width: hingeProfileImageDimension(width),
            borderRadius: `0px 0px ${hingeProfileItemBorderRadius} ${hingeProfileItemBorderRadius}`,
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >
          {/* Divider */}
          <Divider sx={{ width: '100%', my: 0 }} orientation="horizontal" />

          {/* Feedback and Verdict */}
          {viewFeedbackAndVerdictForItemJSX(datingProfile.mediaFeedback[imageIndex], 'media', datingProfile.type)}

        </Box>
      }
    </Box>
  )
}